<div class="picklist-container">
  <div>
    <form [formGroup]="formularioDelPadre()" class="form-container">
      <div class="form-grid">
        <div class="form-field">
          <label for="nombre-grupo">Nombre del Grupo</label>
          <input id="nombre-grupo" pInputText formControlName="nombre_grupo" class="input-full-width" />
        </div>
        <div class="form-field">
          <label for="descripcion">Descripción</label>
          <textarea id="descripcion" rows="2" cols="30" pTextarea formControlName="descripcion" class="textarea-full-width"></textarea>
        </div>
        <div></div>
      </div>
    </form>
    <div class="list-panel-a">
      <div class="list-header">{{ targetHeader() }}</div>
      <div class="filter-input-container">
        <input #txtTarget type="text" placeholder="Buscar..." (input)="targetFilterChange.emit(txtTarget.value)">
      </div>
      <ul class="list-items">
        @for (item of targetItems(); track getTrackByValue(item)) {
          @if (esGrupo(item)) {
              <div class="list-item grupo-item" [ngClass]="{'bg-green-400': item.clientes[0]?.tipo !== 'seleccionado'}">
                  <div class="grupo-header">
                      <button class="toggle-btn" (click)="toggleGrupo(item)">
                          {{ item.expandido ? '-' : '+' }}
                      </button>
                      <span>{{ item.nombre_grupo }}</span>
                      <button class="move-btn" (click)="deselectItem.emit(item)">➔</button>
                  </div>
                  @if (item.expandido) {
                      <div class="grupo-clientes">
                          @for (c of item.clientes; track c.entC_Codigo) {
                              <div class="cliente-row">
                                  {{ c.razon_social }} ({{ c.entC_DocIden }})
                                  <!-- <button class="move-btn" (click)="deselectItem.emit(c)">➔</button> -->
                              </div>
                          }
                      </div>
                  }
              </div>
          } @else {
              <div class="list-item cliente-item" [ngClass]="{'bg-green-400': item.tipo !== 'seleccionado'}">
                  <div class="cliente-row">
                      {{ item.razon_social }} ({{ item.entC_DocIden }})
                      <button class="move-btn" (click)="deselectItem.emit(item)">➔</button>
                  </div>
              </div>
          }
      } @empty {
        <li class="no-items">No hay elementos seleccionados.</li>
      }
      </ul>
    </div>
  </div>

  <div class="list-panel-b">
    <div class="list-header">{{ sourceHeader() }}</div>
    <div class="filter-input-container">
      <!-- ✅ Filtros de checkboxes -->
      <div class="checkbox-group mb-2">
        <label>
          <input type="checkbox"
                  [checked]="showGroups()"
                  (change)="showGroupsChange.emit($any($event.target).checked)"
                  [disabled]="showGroups() && !showClients()" />
          Grupo
        </label>
        <label>
          <input type="checkbox"
                  [checked]="showClients()"
                  (change)="showClientsChange.emit($any($event.target).checked)"
                  [disabled]="showClients() && !showGroups()" />
          Cliente
        </label>
      </div>
      <!-- Nuevo select para filtrar por tipo de cliente -->
      <select
        #selectSource
        class="w-full p-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 mb-2"
        (change)="clientTypeFilterChange.emit(selectSource.value)">
        <option value="">-- Selecciona un Tipo --</option>
        @for (type of clientTypes(); track type.value) {
          <option [value]="type.value">{{ type.name }}</option>
        }
      </select>
      <!-- Input de búsqueda -->
      <input #txtSource type="text" placeholder="Buscar..." (input)="sourceFilterChange.emit(txtSource.value)">
    </div>
    <ul class="list-items">
      @for (item of sourceItems(); track getTrackByValue(item)) {
        @if (esGrupo(item)) {
        <div class="list-item grupo-item" [ngClass]="{'bg-red-400': item.clientes[0]?.tipo !== 'disponible'}">
          <div class="grupo-header">
            <button class="toggle-btn" (click)="toggleGrupo(item)">
              {{ item.expandido ? '-' : '+' }}
            </button>
            <span>{{ item.nombre_grupo }}</span>
            <button class="move-btn" (click)="selectItem.emit(item)">⬅</button>
          </div>
          @if (item.expandido) {
          <div class="grupo-clientes">
            @for (c of item.clientes; track c.entC_Codigo) {
            <div class="cliente-row">
              {{ c.razon_social }} ({{ c.entC_DocIden }})
              <button class="move-btn" style="margin-right: 25px;" (click)="selectItem.emit(c)">⬅</button>
            </div>
            }
          </div>
          }
        </div>
        } @else {
        <div class="list-item cliente-item" [ngClass]="{'bg-red-400': item.tipo !== 'disponible'}">
          <div class="cliente-row">
            {{ item.razon_social }} ({{ item.entC_DocIden }})
            <button class="move-btn" (click)="selectItem.emit(item)">⬅</button>
          </div>
        </div>
        }
      } @empty {
        <li class="no-items">No hay elementos disponibles.</li>
      }
    </ul>
  </div>
</div>
